// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alt-customers-content {
    min-width: 360px;
    max-width: 520px;
    padding-top: 8px;
    overflow: visible;
    padding-left: 4px;
    padding-right: 4px;
}

.alt-customers-empty {
    text-align: center;
    color: #222;
    font-size: 16px;
    padding: 16px 0;
}

.customer-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 10px;
}

.customer-row .form-control {
    max-width: 260px;
}

.alt-customers-actions {
    display: flex;
    justify-content: center;
    gap: 16px;
    padding: 8px 24px 8px;
    margin: 0;
    overflow: visible;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/shared/alternate-customers-dialog/alternate-customers-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,SAAS;IACT,iBAAiB;AACrB","sourcesContent":[".alt-customers-content {\n    min-width: 360px;\n    max-width: 520px;\n    padding-top: 8px;\n    overflow: visible;\n    padding-left: 4px;\n    padding-right: 4px;\n}\n\n.alt-customers-empty {\n    text-align: center;\n    color: #222;\n    font-size: 16px;\n    padding: 16px 0;\n}\n\n.customer-row {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-bottom: 10px;\n}\n\n.customer-row .form-control {\n    max-width: 260px;\n}\n\n.alt-customers-actions {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    padding: 8px 24px 8px;\n    margin: 0;\n    overflow: visible;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
